<div class="run-now-dialog" [class.has-schema]="hasSchema">
  <div class="dialog-header">
    <h2 class="dialog-title">Run Routine</h2>
    <button mat-icon-button class="close-button" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <div class="routine-info">
      <p class="routine-name">{{ data.routineName }}</p>
      @if (data.workflowName) {
        <p class="workflow-name">Workflow: {{ data.workflowName }}</p>
      }
    </div>

    <!-- Variable schema form (when schema is present) -->
    @if (hasSchema) {
      @if (hasStoredArguments) {
        <div class="stored-arguments-hint">
          <mat-icon class="hint-icon">info</mat-icon>
          <span>Pre-filled from this routine's stored arguments</span>
        </div>
      }
      <app-variable-schema-form
        [schema]="data.variableSchema"
        [initialValues]="schemaInitialValues"
        (valuesChange)="onSchemaValuesChange($event)"
        (validChange)="onSchemaValidChange($event)">
      </app-variable-schema-form>

      <mat-divider class="schema-divider"></mat-divider>
    }

    <div class="head-version-option">
      <mat-checkbox [(ngModel)]="useHead" color="primary">
        Use HEAD version for this run
      </mat-checkbox>
      <div class="option-hint">
        <mat-icon class="hint-icon">info</mat-icon>
        <span>Run against the current development version instead of the latest published version</span>
      </div>
    </div>
  </div>

  <div class="dialog-actions">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary"
            (click)="onRun()"
            [disabled]="!schemaValid">
      <mat-icon>play_arrow</mat-icon>
      Run
    </button>
  </div>
</div>
